module.exports = __webpack_public_path__ + "9cedf40c160769863125cf919c9f5f39.png";